import CheckupNavbar from "@/components/growthcheckup/CheckupNavbar";
import CheckupHero from "@/components/growthcheckup/CheckupHero";
import CheckupMeetXpress from "@/components/growthcheckup/CheckupMeetXpress";
import CheckupWhatYouGet from "@/components/growthcheckup/CheckupWhatYouGet";
import CheckupFitSection from "@/components/growthcheckup/CheckupFitSection";
import CheckupWhatWeReview from "@/components/growthcheckup/CheckupWhatWeReview";
import CheckupHowItWorks from "@/components/growthcheckup/CheckupHowItWorks";
import CheckupFinalCta from "@/components/growthcheckup/CheckupFinalCta";
import CheckupForm from "@/components/growthcheckup/CheckupForm";
import CheckupFAQ from "@/components/growthcheckup/CheckupFAQ";
import CheckupStickyMobileCta from "@/components/growthcheckup/CheckupStickyMobileCta";
import ExitIntentModal from "@/components/growthcheckup/ExitIntentModal";
import LandingGoogleReviews from "@/components/landing/LandingGoogleReviews";
import TestimonialCarousel from "@/components/landing/TestimonialCarousel";
import Footer from "@/components/Footer";

const GetGrowthScorePage = () => (
  <div className="min-h-screen pb-16 md:pb-0">
    <CheckupNavbar />
    <CheckupHero />
    <CheckupMeetXpress />
    <CheckupWhatYouGet />
    <CheckupFitSection />
    <LandingGoogleReviews />
    <CheckupWhatWeReview />
    <TestimonialCarousel />
    <CheckupHowItWorks />
    <CheckupForm />
    <CheckupFAQ />
    <CheckupFinalCta />
    <Footer />
    <CheckupStickyMobileCta />
    <ExitIntentModal />
  </div>
);

export default GetGrowthScorePage;
